import { HeaderLevel } from '../types/AgilityTypes';

export const getHeaderLevel = (level?: HeaderLevel): HeaderLevel => {
  if (!level) return 2;
  if (typeof level === 'number' && level >= 1 && level <= 6) {
    return level;
  }
  if (typeof level === 'string' && level.startsWith('h')) {
    const numLevel = parseInt(level.substring(1), 10);
    if (numLevel >= 1 && numLevel <= 6) {
      return numLevel as HeaderLevel;
    }
  }
  return 2;
};

const COLOR_MAP: Record<string, string> = {
  '#fff': 'text-white',
  '#ffffff': 'text-white',
  white: 'text-white',
  black: 'text-gray-900',
  blue: 'text-blue',
  'dark-blue': 'text-dark-blue',
  'light-blue': 'text-light-blue',
  yellow: 'text-yellow',
  'dark-yellow': 'text-dark-yellow',
  orange: 'text-orange',
  purple: 'text-purple',
  'gray-50': 'text-gray-50',
  'gray-100': 'text-gray-100',
  'gray-200': 'text-gray-200',
  'gray-300': 'text-gray-300',
  'gray-400': 'text-gray-400',
  'gray-500': 'text-gray-500',
  'gray-600': 'text-gray-600',
  'gray-700': 'text-gray-700',
  'gray-800': 'text-gray-800',
  'gray-900': 'text-gray-900',
  'primary-100': 'text-primary-100',
  'primary-200': 'text-primary-200',
  'primary-300': 'text-primary-300',
  'primary-400': 'text-primary-400',
  'primary-500': 'text-primary-500',
  'primary-600': 'text-primary-600',
  'primary-700': 'text-primary-700',
  'primary-800': 'text-primary-800',
  'primary-900': 'text-primary-900',
  'secondary-100': 'text-secondary-100',
  'secondary-200': 'text-secondary-200',
  'secondary-300': 'text-secondary-300',
  'secondary-400': 'text-secondary-400',
  'secondary-500': 'text-secondary-500',
  'secondary-600': 'text-secondary-600',
  'secondary-700': 'text-secondary-700',
  'secondary-800': 'text-secondary-800',
  'secondary-900': 'text-secondary-900',
  'blue-tint': 'text-blue-tint',
  'yellow-tint': 'text-yellow-tint',
  'orange-tint': 'text-orange-tint',
  '#f4aa00': 'text-yellow',
  '#F4AA00': 'text-yellow',
  'tertiary.main': '#00C4B3',
  'primary.main': '#003b5c',
  primary: '#1976D2',
};

const DEFAULT_TEXT_COLOR = 'text-white';

export const getTextColorClass = (color?: string): string => {
  if (!color) return DEFAULT_TEXT_COLOR;
  const normalized = color.trim().toLowerCase();
  if (COLOR_MAP[normalized]) return COLOR_MAP[normalized];
  if (normalized.startsWith('#')) return color; // Return original hex if not mapped
  if (normalized.startsWith('text-')) return color; // Allow custom Tailwind classes
  return DEFAULT_TEXT_COLOR;
};

export const getTextAlignmentClass = (
  alignment: string | undefined,
  defaultAlignment: 'left' | 'right' | 'center' = 'center',
) => {
  switch (alignment?.toLowerCase()) {
    case 'left':
      return 'text-left';
    case 'right':
      return 'text-right';
    case 'center':
      return 'text-center';
    default:
      return `text-${defaultAlignment}`;
  }
};
